import {connect} from 'react-redux';

import {Handler} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {ErrorWithData} from '../../../../libs/shared/helpers/src/types/customErrors';
import {
  createSelector,
  makeMapDispatchToProps,
  makeMapStateToProps,
} from '../../../../srcCommon/helpers/reselectHelpers';
import {CalendarVersionModel} from '../../../models/api/calendarVersionModel';
import {AppState} from '../../../store/appState';
import {
  CalendarVersionPatch,
  updateCalendarVersionAction,
} from '../../../store/data/calendarVersions/calendarVersionsActions';
import {getDefaultTeammateAccessRole} from '../../../store/data/company/companySelectors';
import {getCalendars} from '../../../store/data/dataSelectors';
import {EditCalendarDropdown} from './editCalendarDropdown';

/*
 * Props.
 */

interface EditCalendarDropdownContainerProps {
  calendarVersion: CalendarVersionModel;
  onRequestClose: Handler | undefined;
}

/*
 * Selectors.
 */

function getCalendarId(_state: AppState, props: EditCalendarDropdownContainerProps) {
  return props.calendarVersion.calendarId;
}

function makeGetCalendar() {
  return createSelector([getCalendars, getCalendarId], (calendars, calendarId) => {
    const calendar = calendars[calendarId];
    if (!calendar) {
      throw new ErrorWithData('A calendar could not be found for this ID', {calendarId});
    }

    return calendar;
  });
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<EditCalendarDropdownContainerProps>()(() => ({
  calendar: makeGetCalendar(),
  defaultTeammateAccessRole: getDefaultTeammateAccessRole,
}));

const mapDispatchToProps = makeMapDispatchToProps<EditCalendarDropdownContainerProps>()((props) => {
  const {calendarVersion, onRequestClose} = props;
  return {
    onSaveClick: (patch: CalendarVersionPatch) => {
      if (onRequestClose) {
        onRequestClose();
      }

      return updateCalendarVersionAction(calendarVersion.id, patch);
    },
  };
});

export const EditCalendarDropdownContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditCalendarDropdown);
